import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PageShell } from './_PageShell';

export function TeamDetail() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  return (
    <PageShell title={t('teamDetail.title', { id })} subtitle={t('teamDetail.subtitle')}>
      <p className="text-sm text-hint">{t('teamDetail.body')}</p>
    </PageShell>
  );
}
